<template>
  <div class="home">
    <Topmenu />

    <div class="subbanner pr" style="height: 400px">
      <img style="height: auto" src="@/assets/bannerbig3.png" />
    </div>

    <div v-show="false" class="tit">
      <img src="@/assets/tit_product.jpg" />
    </div>
    <div v-show="false" class="produtList">
      <ul>
        <li
          class="product pr fadeInUp animated"
          style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp"
        >
          <router-link to="/hospital/case01">
            <img src="@/assets/pro011.jpg" />
            <div class="introText">
              <span>医疗</span>
            </div>
            <div class="introText2">
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;致力于医院精细化运营管理研究，助力医疗机构提升管理效率。</p>
              <cite>Read More&gt;&gt;</cite>
            </div>
          </router-link>
        </li>
        <li
          class="product pr fadeInUp animated"
          style="visibility: visible; animation-delay: 0.9s; animation-name: fadeInUp"
        >
          <router-link to="/anquan/case01">
            <img src="@/assets/pro03.jpg" />
            <div class="introText">
              <span>安全</span>
            </div>
            <div class="introText2">
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为政府、企事业单位提供全面的信息安全整体解决方案。</p>
              <cite>Read More&gt;&gt;</cite>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="team" ref="zixunbox" id="scrollZixun">
      <div class="tit">
        <img src="@/assets/Consultation.png" />
      </div>
      <div class="" style="width: 1200px; margin: 0 auto; line-height: 32px; overflow: hidden">
        <img style="float: left; width: 380px; height: 280px; margin-left: 10px" src="@/assets/peixun.jpg" />
        <p style="width: 780px; float: right">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;绩效管理是现代医院管理的重要方法和科学的战略管理工具。绩效管理过程是各级管理者和医务工作者为了达到医院战略发展目标共同参与绩效计划制定、绩效辅导沟通、绩效考核评价、绩效结果应用、绩效目标提升的持续循环过程（PDCA闭环）。良好的绩效管理，有助于带动全院职工的工作积极性，提高工作效率、提高医疗质量、改善服务水平、降低运营成本，全面提升医院的精细化管理水平。<br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了充分发挥绩效管理的“指挥棒”、“风向标”作用，在国家有关政策的指导下，并结合公立医院的特点，我公司提出
          <span style="color: #f00; font-weight: bold"
            >以预算为导向，以工作量为核心，辅以质量控制、成本控制、医德医风、患者满意度等因素，针对医、护、技、药、管的不同岗位，形成一套完善的绩效考核与绩效工资核算体系</span
          >，充分体现劳务价值，体现多劳多得、优绩优酬的分配思想，全面推动医院各项管理工作的信息化、规范化，助力医院走向精细化管理的飞速发展之路！
        </p>
      </div>
    </div>
    <div class="tit">
      <img src="@/assets/tit_news.jpg" />
    </div>
    <div class="wrapcon">
      <div class="model_tab">
        <div class="tabbox" style="margin-top: 0">
          <div class="tabcon">
            <ul>
              <li>
                <router-link to="/news/case01">
                  <img src="@/assets/newsimg.jpg" />
                  <span>医疗控费难，难在何处？</span>
                  <p>
                    近年来医疗机构迎来了前所未有的发展机遇，诊疗服务能力、发展规模和现实效益得到了显著提升。然而医疗费用过快增长，即加重患者负担，也在一定程度上加大...
                  </p>
                  <cite>READ MORE &gt;</cite>
                </router-link>
              </li>
              <li>
                <router-link to="/news/case02">
                  <img src="@/assets/newsimg3.jpg" />
                  <span>从绩效考核指标看医院功能定位导向</span>
                  <p>
                    经常看到有人说，绩效考核是指挥棒。期待已久的三级公立医院考核具体政策终于出台了。2019年1月16日《国务院办公厅关于加强三级公立医院绩效考核工作的意见》...
                  </p>
                  <cite>READ MORE &gt;</cite>
                </router-link>
              </li>
              <li>
                <router-link to="/news/case03">
                  <img src="@/assets/newsimg1.jpg" />
                  <span>药占比、耗占比考核都没了？</span>
                  <p>
                    2019年1月30日，国务院办公厅印发《关于加强三级公立医院绩效考核工作的意见》，要求在2019年12月底前完成第一次全国三级公立医院绩效考核工作...
                  </p>
                  <cite>READ MORE &gt;</cite>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Topmenu from '@/components/topmenu'
import Bottom from '@/components/bottom'
//import videojs from 'video.js'
// this.$video 挂载全局
export default {
  name: 'Home',
  components: {
    Topmenu,
    Bottom
  },
  data() {
    return {}
  },
  methods: {
    // 初始化video播放视频

    // 点击咨询菜单 滚动到锚点定位区域
    getLocal() {
      if (this.$route.path == '/zixun') {
        let ele = this.$refs.zixunbox
        ele.scrollIntoView(true)
      }
    }
  },
  watch: {
    $route: {
      handler: 'getLocal'
    }
  },
  created() {
    this.$nextTick(() => {
      this.getLocal()
    })
  }
}
</script>
<style lang="scss" scoped>
.subbanner {
  width: 100%;
  height: 298px;
  overflow: hidden;
}
.subbanner img {
  position: absolute;
  display: block;
  top: 0;
  left: 50%;
  margin-left: -960px;
  width: 1920px;
  height: 298px;
}
.home {
  width: 100%;
  height: 100%;
  .tit {
    margin: 50px auto 0;
    width: 1200px;
  }
  .produtList {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    ul {
      display: flex;
      justify-content: space-between;
    }
  }
  .product {
    width: 590px;
    height: 420px;
    overflow: hidden;
    margin: 0 7px;
  }
  .product img {
    margin-top: -222px;
    opacity: 0.8;
    width: 100%;
  }

  .introText {
    display: block;
    padding: 20px;
    position: absolute;
    top: 20px;
  }
  .introText span {
    font-size: 50px;
    color: #fff;
    font-weight: bold;
    margin-left: 20px;
  }
  .introText p {
    display: block;
    border-bottom: 1px solid #000;
    color: #000;
    margin: 10px 0;
    padding-bottom: 8px;
  }
  .introText cite {
    display: block;
    text-align: right;
    font-weight: bold;
    font-size: 18px;
    color: #000;
  }

  .product .introText2 {
    display: block;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    text-align: left;
  }
  .introText2 p {
    display: block;
    border-bottom: 1px solid #666;
    color: #fff;
    margin: 10px 0;
    padding-bottom: 8px;
    font-size: 16px;
    line-height: 30px;
  }
  .introText2 cite {
    display: block;
    text-align: right;
    font-weight: bold;
    font-size: 18px;
    color: #fff;
  }

  .product .introText2 {
    background: #c21500;
    background: rgba(0, 0, 0, 0.8);
    position: absolute;
    bottom: 0px;
    width: 100%;
    box-sizing: border-box;
    height: 130px;
    overflow: hidden;
    transition: height 450ms;
    padding: 5px 20px 0;
  }
  .product:hover .introText2 {
    color: #999;
    height: 130px;
    width: 100%;
    padding: 5px 20px 0;
    background: rgba(0, 0, 0, 0.95);
  }
  .product:hover .introText2 p {
    color: #fff;
  }
  .product:hover img {
    opacity: 1;
  }
}
.team {
  background: #f8f8f8;
  margin: 0 auto 30px;
  width: 100%;
  padding: 10px 0 25px;
}
.teambox {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  padding-top: 120px;
}
.zhuanjia {
  width: 520px;
  height: 380px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background: #fff;
  padding: 30px;
  position: relative;
}
.photo {
  position: absolute;
  left: 10px;
  top: -120px;
}
.name {
  position: absolute;
  left: 200px;
  top: -50px;
  font-size: 22px;
  color: #000;
}
.zhuanjia p {
  padding-top: 30px;
  color: #000;
  line-height: 30px;
}
.zhuanjia p span {
  display: block;
  margin-top: 15px;
  line-height: 30px;
  padding-left: 30px;
  background: url(../assets/circle.jpg) no-repeat left 11px;
}

.zhuanjia01 {
  margin-left: 30px;
}
.wrapcon {
  width: 1200px;
  margin: 10px auto;
  overflow: hidden;
  padding-bottom: 30px;
}
.tabcon ul li {
  width: 338px;
  border: 1px solid #f1f1f1;
  padding: 20px;
  margin: 10px;
  float: left;
}
.tabcon ul li a img {
  display: block;
  width: 338px;
}
.tabcon ul li a span {
  display: block;
  line-height: 50px;
  font-size: 20px;
  color: #000;
  font-weight: bold;
}
.tabcon ul li a p {
  margin-top: 10px;
  line-height: 30px;
}
.tabcon ul li a cite {
  font-size: 12px;
  font-weight: bold;
  display: block;
  text-align: right;
  line-height: 40px;
}
.tabcon ul li:hover {
  background: #f7f7f7;
  box-shadow: 0 0 5px #f4f4f4;
}
.tabcon ul li a:hover img {
  box-shadow: 0 0 5px #ccc;
}
.tabcon ul li a:hover span {
  color: #d70000;
}
.tabcon ul li a:p {
  color: #000;
}
.tabcon ul li a:hover cite {
  color: #d70000;
}
</style>
